
import { create } from 'zustand';

interface DashboardEditState {
    isEditMode: boolean;
    showAddModal: boolean;
    setEditMode: (mode: boolean) => void;
    toggleEditMode: () => void;
    setShowAddModal: (show: boolean) => void;
}

export const useDashboardEditStore = create<DashboardEditState>((set) => ({
    isEditMode: false,
    showAddModal: false,
    setEditMode: (mode) => set({ isEditMode: mode }),
    toggleEditMode: () => set((state) => ({ isEditMode: !state.isEditMode })),
    setShowAddModal: (show) => set({ showAddModal: show }),
}));
